import React, { useState } from 'react';

const AppraisalObjectionModal = ({ 
  isOpen, 
  onClose, 
  address,
  contract, 
  onSubmit
}) => {
    const appraisalObjectionOptions = [
        "Attach Appraisal",
        "Attach Lender Verification",
      ];

    const [appraisalObjectionType, setAppraisalObjectionType] = useState([]); 
    // const [objectionText, setObjectionText] = useState('');

    const handleCheckboxChange = (option) => {
        setAppraisalObjectionType(prev =>
          prev.includes(option)
            ? prev.filter(item => item !== option)
            : [...prev, option]
        );
      };
    
      const handleSubmit = () => {
        // Build an object with your termination data
        const appraisalData = { 
          appraisalObjectionType
        };
        onSubmit(appraisalData, contract);
      };

  if (!isOpen) return null;

return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-semibold mb-4">Appraisal Objection</h2>
        <p className="text-sm text-gray-700 mb-4">
          You are about to submit an appraisal objection form for <span className="font-bold">{address}</span>.
          Check if you are going to attach supporting documents to send to the seller after you sign the objection form.
        </p>
        <div className='relative mb-4'>
        <div className="max-h-[35vh] overflow-y-scroll">
          {appraisalObjectionOptions.map(option => (
            <div key={option} className="flex items-center p-1">
              <input
                type="checkbox"
                id={option}
                checked={appraisalObjectionType.includes(option)}
                onChange={() => handleCheckboxChange(option)}
              />
              <label htmlFor={option} className="ml-2 text-sm text-gray-700">{option}</label>
            </div>
          ))}
        </div>
        </div>
          {/* <div className="mb-4">
            <label className="block md:text-[14px] text-[12px] text-gray-700 mb-1">Specific Objection:</label>
            <p className="block text-sm text-gray-700 mb-1">Enter your specific objections to the matter(s) you checked above</p>
            <textarea 
              type="text" 
              value={objectionText} 
              onChange={(e) => setObjectionText(e.target.value)} 
              className="border rounded p-2 w-full"
              placeholder="Enter specific objection details"
            />
          </div> */}
          <p className="text-xs text-gray-600 mb-4">
            NOTE: Any agreement on appraisal issues may change your contract and might need to be reported to your lender. Please consult your lender before finalizing any resolution, as changes could affect your loan, delay funding, or require extra repairs.
            <br />
            <br />
            If you and the seller don't agree in writing by the appropriate Resolution Deadline, the contract will terminate—unless you withdraw your appraisal objection before the deadline.
          </p>
        <div className="flex justify-end gap-4">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmit}
            className="px-4 py-2 bg-shi-green text-white rounded hover:bg-green-700"
          >
            Sign and Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppraisalObjectionModal;